module.exports = __webpack_public_path__ + "static/media/ic-location-gray-big.cd26c2c6.svg";